import * as React from "react";
import PropTypes from "prop-types";
import { History } from "history";
import classnames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";

import { RootState } from "../../../state";
import { pushState } from "../../actions/Router";

/**
 * NOTE(miyashiro): https://github.com/kriasoft/react-starter-kit/blob/v0.5.1/src/components/Link/Link.js
 */

function isLeftClickEvent(ev: React.MouseEvent<HTMLAnchorElement>) {
  return ev.button === 0;
}

function isModifiedEvent(ev: React.MouseEvent<HTMLAnchorElement>) {
  return !!(ev.metaKey || ev.altKey || ev.ctrlKey || ev.shiftKey);
}

interface OwnProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to?: string;
  activeClassName?: string;
  disabled?: boolean;
}

interface MappedActions {
  pushState: typeof pushState;
}

type Props = OwnProps & MappedActions;

interface Context {
  history: History;
}

class Link extends React.Component<Props> {
  public static contextTypes = {
    history: PropTypes.object.isRequired,
  };

  public unlistenHistory: () => void = () => {
    /* noop */
  };

  public componentDidMount() {
    const context = this.context as Context;
    this.unlistenHistory = context.history.listen(this.handleHistoryUpdate);
  }

  public componentWillUnmount() {
    this.unlistenHistory();
  }

  public handleClick = (ev: React.MouseEvent<HTMLAnchorElement>) => {
    if (this.props.disabled) {
      ev.preventDefault();
      return;
    }

    if (this.props.onClick) {
      this.props.onClick(ev);
    }
    if (isModifiedEvent(ev) || !isLeftClickEvent(ev)) {
      return;
    }

    if (ev.defaultPrevented === true) {
      return;
    }

    ev.preventDefault();
    if (this.props.to) {
      const result = this.props.pushState({ path: this.props.to });
      // Scroll to top only when succeeded to pushState
      if (result) {
        window.scrollTo(0, 0);
      }
    }
  };

  public handleHistoryUpdate = () => {
    this.forceUpdate();
  };

  public getClassName = () => {
    const { to, className: defaultClassName, activeClassName } = this.props;
    const context = this.context as Context;
    if (to === context.history.location.pathname) {
      return classnames(defaultClassName, activeClassName);
    }
    return defaultClassName;
  };

  public render() {
    const { to, activeClassName, children, pushState, ...props } = this.props;

    return (
      <a {...props} href={to} className={this.getClassName()} onClick={this.handleClick}>
        {children}
      </a>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<RootState>): MappedActions {
  return bindActionCreators(
    {
      pushState,
    },
    dispatch
  );
}

export default connect(null, mapDispatchToProps)(Link);



// WEBPACK FOOTER //
// ./frontend/src/common/components/router/Link.tsx